import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle, Crown } from 'lucide-react';
const NAMES = ['María', 'Ana', 'Lucía', 'Carmen', 'Valentina', 'Sofía', 'Isabella', 'Camila', 'Paula', 'Andrea', 'Gabriela', 'Daniela', 'Fernanda', 'Alejandra', 'Natalia'];
const COUNTRIES = ['Argentina', 'México', 'Colombia', 'Chile', 'España', 'Perú', 'Ecuador', 'Uruguay', 'Costa Rica', 'República Dominicana', 'Guatemala', 'Paraguay', 'Bolivia', 'Honduras', 'Venezuela'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    country: '',
    isPremium: false
  });
  const showCountRef = useRef(0);
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCountry = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
      const isPremium = showCountRef.current % 2 === 1;
      showCountRef.current += 1;
      setData({
        name: randomName,
        country: randomCountry,
        isPremium
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimeout = setTimeout(showPopup, 5000);
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.random() * (15000 - 8000) + 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-260">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className={`fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-xl p-4 max-w-xs md:max-w-sm flex items-start gap-3 ${data.isPremium ? 'border-l-4 border-amber-500' : 'border-l-4 border-green-500'}`} data-id="element-261">
          <div className={`p-2 rounded-full shrink-0 ${data.isPremium ? 'bg-amber-100' : 'bg-green-100'}`} data-id="element-262">
            {data.isPremium ? <Crown className="w-6 h-6 text-amber-600" data-id="element-263" /> : <CheckCircle className="w-6 h-6 text-green-600" data-id="element-264" />}
          </div>
          <div className="flex-1 pr-6" data-id="element-265">
            <p className="text-sm font-medium text-gray-900" data-id="element-266">
              <span className="font-bold" data-id="element-267">{data.name}</span> de {data.country}
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-268">
              {data.isPremium ? 'acaba de comprar el Paquete Premium 👑' : 'acaba de comprar el Manual + 800 Recetas'}
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-269">Hace unos segundos</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-270">
            <X className="w-4 h-4" data-id="element-271" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}